(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vinoteca-campaign-popup')) {
    customElements.define('vinoteca-campaign-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.card = this.querySelector('[data-popup-card]');
        this.reopen = this.querySelector('[data-popup-reopen]');
        this.closeButton = this.querySelector('[data-popup-close]');
        this.key = 'vinoteca:campaign-popup:' + this.dataset.scope + ':' + this.dataset.campaign;
        this.editor = this.dataset.editor === 'true';
        this.closeButton.addEventListener('click', () => this.close(), options);
        this.reopen.addEventListener('click', () => this.show(true), options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.card.hidden) this.close();
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && event.target.contains(this)) this.show(false);
        }, options);
        window.addEventListener('storage', event => {
          if (event.key === this.key && event.newValue && !this.editor) this.close();
        }, options);
        if (this.editor) {
          this.show(false);
        } else if (this.hasSeen()) {
          this.setReopen();
        } else {
          this.timer = setTimeout(() => {
            if (this.hasSeen()) this.setReopen();
            else if (document.visibilityState === 'visible') this.show(false);
            else document.addEventListener('visibilitychange', () => {
              if (document.visibilityState === 'visible' && !this.hasSeen()) this.show(false);
            }, options);
          }, Number(this.dataset.delay) * 1000);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller.abort();
      }
      hasSeen() {
        try { if (localStorage.getItem(this.key)) return true; } catch (error) {}
        try { return Boolean(sessionStorage.getItem(this.key)); } catch (error) { return false; }
      }
      remember() {
        if (this.editor) return;
        try { localStorage.setItem(this.key, '1'); } catch (error) {
          try { sessionStorage.setItem(this.key, '1'); } catch (error) {}
        }
      }
      setReopen() {
        this.reopen.hidden = this.dataset.reopen !== 'true';
        this.reopen.setAttribute('aria-expanded', 'false');
      }
      show(focus) {
        this.card.hidden = false;
        this.reopen.hidden = true;
        this.reopen.setAttribute('aria-expanded', 'true');
        this.remember();
        if (focus) this.closeButton.focus({ preventScroll: true });
      }
      close() {
        const restoreFocus = this.card.contains(document.activeElement);
        this.card.hidden = true;
        this.setReopen();
        if (restoreFocus && !this.reopen.hidden) this.reopen.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
